import { fromJS } from 'immutable'
import {
  EMPLOYEE_LEVELS_LIST_REQUEST,
  EMPLOYEE_LEVELS_LIST_SUCCESS,
  EMPLOYEE_LEVELS_LIST_FAILURE,
  EMPLOYEE_LEVELS_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EMPLOYEE_LEVELS_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case EMPLOYEE_LEVELS_LIST_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('employee', fromJS(action.payload.employees))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/employee-levels-list-reducer.js